var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-input"},[_c('div',{staticClass:"search_edit",on:{"click":_vm.search}},[_c('img',{attrs:{"src":require("@assets/images/home/icon_search.png")}}),_c('div',[_vm._v("请输入要搜索的商品")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }